import React, { useCallback, useState, useEffect } from "react";
import axios from "axios";
import { useDelete } from "../customHooks/useDelete/useDelete";
import useEdit from "../customHooks/useEdit/useEdit";
import ConfirmationPrompt from "../components/ConfirmationPrompt";
import { toast } from "react-toastify";
import { ActionCells } from "../components/ActionCells";
import { MODULE_DELETE_URL } from "../app/request/userRequest";
import { TModuleDelete } from "../types/Network_ Request/moduleWiseApiType/deleteApi";
import { TTableAction } from "../types/TableActions";
import PermissionPrompt from "../components/PermissionPrompt";
import { usePermissions } from "../utils/Customhooks/permissionHook/usePermissionHook";
import { deleteQuiz } from "../generatedRequest/quiz";
import { setRerender } from "../generatedSlice/quizSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import useClone from "../customHooks/useClone/useClone";
import ClonePrompt from "../components/ClonePrompt";
import CloneRegionModel from "../components/CloneRegionModel";
import { addQuiz } from "../generatedRequest/quiz";
import { getRegion } from "../app/request/regionRequest";

const moduleName = "Quiz";

const QuizTableAction = ({ quiz }: any) => {
  const [regions, setRegions] = useState<any[]>([]);
  const [showCloneStatusModel, setShowCloneStatusModel] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState<any[]>([]);
  const [statusData, setStatusData] = useState([]);
  const [newPayloads, setNewPayloads] = useState([]);
  const { rerender1 } = useSelector((state: RootState) => state.quiz);
  const { doEdit } = useEdit(moduleName);
  const dispatch = useDispatch();
  const [showPermissionPrompt, setShowPermissionPrompt] =
    useState<boolean>(false);
    

  useEffect(() => {
    const fetchRegions = async () => {
      try {
        const response = await getRegion();
        // console.log("Fetched regions:", response.data); // Add logging here
        setRegions(response.data.data); // Correctly extract the regions array
      } catch (error) {
        console.error("Error fetching regions:", error);
      }
    };

    fetchRegions();
  }, []);

  // Add handleAfterClone callback
// And modify the handleAfterClone function to properly transform data
const handleAfterClone = useCallback(
  (data: any) => {
    dispatch(setRerender(!rerender1));
    
    // Transform the data to include all necessary fields
    const transformedData = data.map((item: any, index: number) => {
      // Get the corresponding region from selectedRegion array
      const region = selectedRegion[index];
      
      return {
        ...item,
        // Use both regionName and name as fallbacks
        regionName: region?.regionName || region?.name,
        res: {
          ...item.res,
          data: {
            ...item.res.data,
            data: {
              ...item.res.data.data,
              quizName: quiz.quizName || quiz.subcategory.subcategoryName,
              subcategory: quiz.subcategory,
              questions: quiz.questions,
              description: quiz.description,
              attributes: quiz.attributes,
              isActive: quiz.isActive,
              status: quiz.status,
              // Ensure regions array is properly formatted
              // region: region?._id,
              regions: [{
                _id: region?._id,
                regionName: region?.regionName || region?.name,
                regionUrl: region?.regionUrl,
                language: region?.language || [],
                status: region?.status || 'active'
              }]
            }
          }
        }
      };
    });
    
    setStatusData(transformedData);
    setShowCloneStatusModel(true);
    console.log('Transformed Status Data:', transformedData);
  },
  [rerender1, dispatch, quiz, selectedRegion]
);
  interface Question {
    _id?: string;
    question: string;
    options: string[];
    correctAnswer: string;
    explanation: string;
  }
  
// useEffect(()=>{
//   // console.log(quiz, "quiz")
//   console.log("quiz", quiz)
// },[quiz])

// In the handleSelectedRegion function, ensure all fields are properly preserved:
const handleSelectedRegion = (data: any) => {
  setSelectedRegion(data);

  const payload = data.map((regionToClone: any) => {
    // Check if this region is already used
    if (quiz?.cloneInfo?.usedRegionIds?.includes(regionToClone.id)) {
      console.log(`Region ${regionToClone.regionName} already has a clone`);
      return null;
    }

    // Create payload matching the transformed structure
    const basePayload = {
      // Use optional chaining and nullish coalescing to handle missing properties
      quizName: quiz?.quizName ?? "",
      description: quiz?.description ?? "",
      isActive: quiz?.isActive ?? false,
      status: quiz?.status ?? "",
      attributes: quiz?.attributes ?? {},
      createdBy: quiz?.createdBy ?? null,
      
      // Handle subcategory data properly
      subcategory: quiz?.subcategory ? {
        ...quiz.subcategory,
        _id: quiz.subcategory._id ?? "",
        subcategoryName: quiz.subcategory.subcategoryName ?? "",
        supportedAttributes: quiz.subcategory.supportedAttributes ?? [],
        description: quiz.subcategory.description ?? "",
        subcategoryImage: quiz.subcategory.subcategoryImage ?? ""
      } : {},
      
      // Handle category properly
      category: quiz?.category ? {
        ...quiz.category,
        _id: quiz.category._id ?? "",
        categoryName: quiz.category.categoryName ?? ""
      } : (quiz?.subcategory?.category ? { ...quiz.subcategory.category } : {}),
      
      questions: Array.isArray(quiz?.questions) ? 
        quiz.questions.map((q: Question) => ({
          ...q,
          question: q.question ?? "",
          options: Array.isArray(q.options) ? [...q.options] : [],
          correctAnswer: q.correctAnswer ?? "",
          explanation: q.explanation ?? ""
        })) : [],
      
      regions: [{
        ...regionToClone,
        regionName: regionToClone.regionName ?? regionToClone.name ?? "",
        regionUrl: regionToClone.regionUrl ?? "",
        language: regionToClone.language ?? [],
        createdBy: regionToClone.createdBy ?? "",
        status: regionToClone.status ?? "active"
      }]
    };

    return {
      ...basePayload,
      res: {
        data: {
          data: basePayload
        }
      }
    };
  }).filter(Boolean); // Remove any null payloads

  setNewPayloads(payload);
  console.log('New Payloads:', payload);
};
  // Add clone hook
  const {
    onClone,
    showClonePrompt,
    setCloneShowPrompt,
    cloneLoading,
    recordToClone,
    onCancelClone,
    cloneRecord,
    newRegion,
  } = useClone(
    addQuiz,
    true,
    handleAfterClone,
    regions,
    selectedRegion,
    newPayloads
  );

  // Add close handlers for clone status
  const onCloseCloneStatus = useCallback(() => {
    setShowCloneStatusModel(false);
  }, []);

  const onBackHandler = useCallback(() => {
    setShowCloneStatusModel(false);
    setCloneShowPrompt(true);
  }, []); 

  const handleAfterDelete = useCallback((success: boolean, response: any) => {
    if (success) {
      toast.success("Record deleted successfully");
      // Force an immediate rerender by dispatching the action
      dispatch(setRerender(!rerender1));
    } else {
      toast.error(response.data.message || "Error deleting record");
    }
  }, [dispatch, rerender1]);

  const { canDo, currentActivity } = usePermissions();

  const { onDelete, deleteRecord, showPrompt, onCancel , loading} = useDelete(
    deleteQuiz,
    true,
    handleAfterDelete
  );
  const actions = ["Edit", "Delete" , "Clone"];

  const handleCancel = useCallback(() => {
    const fn = () => {
      setShowPermissionPrompt(false);
    };
    fn();
  }, []);

  const handleSelect = useCallback(
    (selectedAction: string) => {
      switch (selectedAction) {
        case "Edit":
          // if (canDo(moduleName, "Edit")) {
          doEdit(quiz?._id);
          // } else {
          //   setShowPermissionPrompt(true);
          // }
          break;
        case "Delete":
          // if (canDo(moduleName, "Delete")) {
          onDelete(quiz?._id);
          // } else {
          //   setShowPermissionPrompt(true);
          // }
          break;
        case "Clone":
          // if (canDo(moduleName, "Clone")) {
          // console.log("Regions before cloning:", regions); // Add logging here
          onClone(quiz);
          // } else {
          //   setShowPermissionPrompt(true);
          // }
          break;
        default:
          break;
      }
    },
    [canDo, doEdit, quiz, onDelete,  onClone, regions]
  );
  return (
    <>
      {showClonePrompt && (
        <ClonePrompt
          title="Generate Clone"
          onCancel={onCancelClone}
          onConfirm={cloneRecord}
          isloading={cloneLoading}
          filterRegion={newRegion}
          sendSelectedRegionToParent={handleSelectedRegion}
          // multiSelect={true}
        />
      )}

      {showCloneStatusModel && (
        <CloneRegionModel
          title={"Quiz Clone Status"}
          onCancel={onCloseCloneStatus}
          statusData={statusData}
          onBack={onBackHandler}
          isAccessory={false}
        />
      )}

      {showPermissionPrompt && (
        <PermissionPrompt
          title={"Access Denied"}
          image="/media/auth/permission-error-light.svg"
          message={currentActivity ? currentActivity : ""}
          onCancel={handleCancel}
          moduleName={moduleName}
        />
      )}
      {showPrompt && (
        <ConfirmationPrompt
          title={"Delete Record"}
          message={"Are you sure to delete this record?"}
          onConfirm={deleteRecord}
          onCancel={onCancel}
          isloading={loading}
        />
      )}
      <ActionCells actions={actions} onSelect={handleSelect} />
    </>
  );
};
export default QuizTableAction;
